import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_URL } from "../constants";
import axios from "axios";
import Footer from "../Footer";
import Header from "../Header";

const ConfirmEmail = () => {
  const { token } = useParams();
  const [message, setMessage] = useState("");

  const confirmEmail = async () => {
    axios
      .get(API_URL + `auth/confirm-email/${token}/`)
      .then((res) => {
        setMessage(res.data.detail);
      })
      .catch((err) => {
        setMessage(err.response.data.detail);
      });
  };

  useEffect(() => {
    confirmEmail();
  }, [token]);

  return (
    <div className="body">
      <Header />

      <div className="confirm-email">
        <h2 className="confirm-email-title">Confirm Email</h2>
        <p className="confirm-email-message">{message}</p>
      </div>

      <Footer />
    </div>
  );
};

export default ConfirmEmail;
